import styled from 'styled-components';
import { Container } from 'ui-kit/Loader/styles';

export const Wrapper = styled.div`
  padding: 10px 20px;
  font-size: 14px;
`;

export const FiltersContainer = styled.div`
  margin-top: 25px;
`;

export const FiltersTitle = styled.span`
  font-size: 14px;
  margin: 20px 0;
  display: block;
  margin-left: ${({ isSubcategory }) => (isSubcategory ? '30px' : '0px')};
`;

export const SelectWrapper = styled.div`
  margin-top: 20px;
`;
export const FilterContainer = styled.div`
  ${Container} {
    left: 35%;
  }
`;

export const TextInputContainer = styled.div`
  position: relative;
  bottom: 1px;
  margin-left: 10px;
`;

export const TextInputLabel = styled.label`
  display: 'block';
  font-size: '16px';
  font-weight: '500';
  color: '#374151';
  margin-bottom: '8px';
`;

export const TextInput = styled.input`
  width: 100px;
  padding: '12px 16px';
  border: '1px solid #d1d5db';
  border-radius: '6px';
  font-size: '16px';
  outline: 'none';
  transition: 'all 0.2s ease';
  &:focus {
    bordercolor: '#3b82f6';
  }
`;
